module.exports = __webpack_public_path__ + "img/d15.8b93903d.jpg";